// extracted by mini-css-extract-plugin
var _1 = "lm-u7M0x";
var _2 = "title-DVDqW";
var _3 = "wrap-MyQjZ";
export { _1 as "lm", _2 as "title", _3 as "wrap" }
